import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import {
  AlertTriangle,
  CheckCircle,
} from 'lucide-react';

const CompareResult = ({ compareResult }) => {
  if (!compareResult) return null;

  return (
    <Card className="border-[#4B6651] bg-white" data-testid="compare-result">
      <CardHeader>
        <CardTitle className="text-lg font-['Work_Sans']">
          Exam Comparison
          <span className="text-sm font-normal text-[#5C5F5C] ml-2">
            {new Date(compareResult.exam_1.date).toLocaleDateString()} vs {new Date(compareResult.exam_2.date).toLocaleDateString()}
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
          {compareResult.changes.new_abnormal.length > 0 && (
            <div className="p-3 bg-[#D94F4F]/10 rounded-lg text-center">
              <p className="text-xl font-semibold text-[#D94F4F]">{compareResult.changes.new_abnormal.length}</p>
              <p className="text-xs text-[#D94F4F]">New Abnormal</p>
            </div>
          )}
          {compareResult.changes.resolved.length > 0 && (
            <div className="p-3 bg-[#4B6651]/10 rounded-lg text-center">
              <p className="text-xl font-semibold text-[#4B6651]">{compareResult.changes.resolved.length}</p>
              <p className="text-xs text-[#4B6651]">Resolved</p>
            </div>
          )}
          {compareResult.changes.worsened.length > 0 && (
            <div className="p-3 bg-[#C06144]/10 rounded-lg text-center">
              <p className="text-xl font-semibold text-[#C06144]">{compareResult.changes.worsened.length}</p>
              <p className="text-xs text-[#C06144]">Changed</p>
            </div>
          )}
          <div className="p-3 bg-[#F8F7F4] rounded-lg text-center">
            <p className="text-xl font-semibold text-[#5C5F5C]">{compareResult.changes.unchanged.length}</p>
            <p className="text-xs text-[#5C5F5C]">Unchanged</p>
          </div>
        </div>

        {compareResult.changes.new_abnormal.length > 0 && (
          <div className="mb-3">
            <p className="text-xs font-semibold text-[#D94F4F] uppercase mb-1">New Abnormal Findings</p>
            {compareResult.changes.new_abnormal.map((c) => (
              <div key={`new-${c.label}`} className="flex items-center gap-2 text-sm py-1">
                <AlertTriangle className="w-3 h-3 text-[#D94F4F]" />
                <span className="text-[#2A2C2A]">{c.label}: {c.from || 'normal'} → {c.to}</span>
              </div>
            ))}
          </div>
        )}
        {compareResult.changes.resolved.length > 0 && (
          <div className="mb-3">
            <p className="text-xs font-semibold text-[#4B6651] uppercase mb-1">Resolved</p>
            {compareResult.changes.resolved.map((c) => (
              <div key={`resolved-${c.label}`} className="flex items-center gap-2 text-sm py-1">
                <CheckCircle className="w-3 h-3 text-[#4B6651]" />
                <span className="text-[#2A2C2A]">{c.label}: {c.from} → {c.to || 'normal'}</span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CompareResult;
